import React from "react"
import {
  MuiEvent,
  GridRowId,
  GridEventListener,
  GridRowModesModel,
  GridRowModes,
  GridRowModel,
  GridRowParams,
} from "@mui/x-data-grid-pro"

import { EditorState } from "./state"

type SDT = React.Dispatch<React.SetStateAction<EditorState>>

export interface IEditorApi {
  setRowModesModel: (model: GridRowModesModel) => void;
  start: (id: string, fieldToFocus: string) => void;
  save: (id: string) => void;
  cancel: (id: string) => void;
  isInEditMode: (id: string) => boolean;
}

export const initApi = (state_: EditorState, setState_: SDT): IEditorApi => {

  const setRowModesModel: IEditorApi["setRowModesModel"] = (newModel) => {
    setState_((prev) => ({
      ...prev,
      rowModes: newModel
    }))
  }

  const start: IEditorApi["start"] = (id, fieldToFocus) => {
    setState_((prev) => ({
      ...prev,
      rowModes: {
        ...prev.rowModes,
        [id]: { mode: GridRowModes.Edit, fieldToFocus }
      }
    }))
  }

  const save: IEditorApi["save"] = (id) => {
    setState_((prev) => ({
      ...prev,
      rowModes: {
        ...prev.rowModes,
        [id]: { mode: GridRowModes.View }
      }
    }))
  }

  const cancel: IEditorApi["cancel"] = (id) => {
    setState_((prev) => ({
      ...prev,
      rowModes: {
        ...prev.rowModes,
        [id]: { mode: GridRowModes.View, ignoreModifications: true }
      }
    }))
  }

  const isInEditMode: IEditorApi["isInEditMode"] = (id) => {
    return state_.rowModes[id]?.mode === GridRowModes.Edit
  }

  return {
    setRowModesModel,
    start,
    save,
    cancel,
    isInEditMode,
  }
}
